import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { api } from "../lib/api";

export default function FeaturedWork() {
  const [projects, setProjects] = useState([]);

  useEffect(() => {
    api.get("/projects", { params: { featured: true } })
      .then((r) => setProjects(r.data))
      .catch(() => {});
  }, []);

  return (
    <section className="bg-bone" data-testid="featured-work-section">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-24 md:py-36">
        <div className="grid grid-cols-12 gap-6 mb-16 md:mb-24 items-end">
          <div className="col-span-12 md:col-span-6">
            <p className="text-[11px] uppercase tracking-[0.3em] text-muteInk mb-4">— Selected Work</p>
            <h2 className="font-serif text-4xl md:text-6xl leading-[1.02] tracking-tight text-ink">
              Spaces we've<br /><span className="italic text-clay">recently made.</span>
            </h2>
          </div>
          <div className="col-span-12 md:col-span-3 md:col-start-10 text-right">
            <Link to="/work" data-testid="featured-view-all" className="editorial-link inline-block text-[12px] uppercase tracking-[0.22em] text-ink">
              View archive →
            </Link>
          </div>
        </div>

        {/* Bento asymmetric grid */}
        <div className="grid grid-cols-12 gap-4 md:gap-6">
          {projects.map((p, i) => {
            const layouts = [
              "col-span-12 md:col-span-8 md:row-span-2 h-[420px] md:h-[720px]",
              "col-span-12 md:col-span-4 h-[300px] md:h-[350px]",
              "col-span-12 md:col-span-4 h-[300px] md:h-[350px]",
              "col-span-12 md:col-span-12 h-[380px] md:h-[520px]",
            ];
            const layout = layouts[i % layouts.length];
            return (
              <motion.div
                key={p.id}
                initial={{ opacity: 0, y: 60 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-80px" }}
                transition={{ duration: 0.9, delay: (i % 4) * 0.08, ease: [0.22, 1, 0.36, 1] }}
                className={`${layout} clip-frame relative group hoverable`}
                data-testid={`featured-project-${p.id}`}
              >
                <Link to={`/work/${p.id}`} className="block h-full w-full relative">
                  <img src={p.cover_image} alt={p.title} className="w-full h-full object-cover" />
                  <div className="absolute inset-0 bg-gradient-to-t from-ink/70 via-ink/10 to-transparent opacity-90" />
                  <div className="absolute inset-0 p-6 md:p-8 flex flex-col justify-end text-bone">
                    <p className="text-[10px] uppercase tracking-[0.3em] opacity-70">{p.category} · {p.year}</p>
                    <h3 className="font-serif text-2xl md:text-4xl mt-2 leading-tight">{p.title}</h3>
                    <p className="text-[12px] uppercase tracking-[0.22em] mt-2 opacity-75">{p.location}</p>
                  </div>
                  <span className="absolute top-6 right-6 w-9 h-9 rounded-full bg-bone/90 text-ink flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-500">↗</span>
                </Link>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
